/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyCurrencyRubleIcon24Solid = forwardRef('MoneyCurrencyRubleIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.5 14.25H9.25v2.5H14a1.25 1.25 0 1 1 0 2.5H9.25V21a1.25 1.25 0 1 1-2.5 0v-1.75H5a1.25 1.25 0 1 1 0-2.5h1.75v-2.5H5a1.25 1.25 0 1 1 0-2.5h1.75v-7a2 2 0 0 1 2-2h5.75a5.75 5.75 0 0 1 0 11.5Zm-5.25-2.5v-6.5h5.25a3.25 3.25 0 0 1 0 6.5H9.25Z" })));
});
